import { Link } from "react-router-dom";
import { Seo } from "../components/site/Seo";
import { PageHero } from "../components/site/PageHero";
import { ServicesGrid } from "../components/site/ServicesGrid";
import { CtaFinal } from "../components/site/CtaFinal";
import { QUOTE_PATH } from "../lib/site";

export default function ServicosPage() {
  return (
    <>
      <Seo title="Serviços de Instalação Fotovoltaica | Mega Solar" path="/servicos"
        description="Instalação de painéis solares fotovoltaicos, soluções residenciais e empresariais, avaliação e dimensionamento de sistemas. Conheça os serviços da Mega Solar." />
      <PageHero testId="services-hero" eyebrow="Serviços" lines={["Soluções de energias", "renováveis, do estudo", "à instalação."]}
        text="Os serviços da Mega Solar centram-se na instalação de sistemas fotovoltaicos para habitações e empresas. Os serviços assinalados como «sob consulta» estão sujeitos a confirmação."
        image="/images/instalacao.jpg" alt="Instalador a colocar um painel solar num telhado">
        <Link to={QUOTE_PATH} className="btn-gold mt-10" data-testid="services-hero-quote-button">Pedir Orçamento Gratuito</Link>
      </PageHero>
      <section data-testid="services-page-grid" className="bg-paper pb-24 sm:pb-32">
        <div className="container-x"><ServicesGrid /></div>
      </section>
      <CtaFinal />
    </>
  );
}
